import React, {Component} from "react";
import "./profile/container/profile/css/main-profile.min.css";
import "./project/container/Project/css/main-projects.min.css";
import "react-toastify/dist/ReactToastify.css";
import {Redirect} from "react-router-dom";
import {authService} from "./auth";
import Header from "./Header";

class Forbidden extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loginSuccess: authService.isAuthenticated()
        };
    }
    render(){
        if (!this.state.loginSuccess) {
            return <Redirect to='/login'/>
        } else {
            return <div className="wrapper projectpage profilepage pabout ppersonal">
                <Header hamburgerVisibility={false}/>
                <main className="dgcontainer hm3col">
                    <div className="container">
                        <div className="err404contbx" style={{marginTop:'70px'}}>
                            <img src="https://cdn.dscovr.com/images/AccessDeniedIMG.webp"
                            onError={(e)=>{e.target.onerror = null; e.target.src="https://cdn.dscovr.com/images/AccessDeniedIMG.png"}}
                            className="img-fluid" alt="Error image"/>
                                <h1 style={{fontSize: '32px'}}>Access Denied</h1>
                                <h2>due to the user privacy settings</h2>
                        </div>
                    </div>
                </main>
            </div>
        }

    }
}
export default Forbidden

